import { render, staticRenderFns } from "./PerfumeDataTable.vue?vue&type=template&id=62041168&scoped=true"
import script from "./PerfumeDataTable.vue?vue&type=script&lang=js"
export * from "./PerfumeDataTable.vue?vue&type=script&lang=js"
import style0 from "./PerfumeDataTable.vue?vue&type=style&index=0&id=62041168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62041168",
  null
  
)

export default component.exports